import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {SignUpForm} from '../../features/sign-up'
import SignupFormComponentWrapper from './SignupFormComponentWrapper'

const propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  leadSource: PropTypes.string,
  formFieldProductTypeValue: PropTypes.string,
  formFieldProductTypeHidden: PropTypes.bool,
  formFieldFullNameValue: PropTypes.string,
  formFieldFullNameHidden: PropTypes.bool,
  formFieldCompanyNameValue: PropTypes.string,
  formFieldCompanyNameHidden: PropTypes.bool,
  formFieldCountryValue: PropTypes.string,
  formFieldCountryHidden: PropTypes.bool,
  formFieldEmailValue: PropTypes.string,
  formFieldEmailHidden: PropTypes.bool,
  formFieldCountryCodeValue: PropTypes.string,
  formFieldCountryCodeHidden: PropTypes.bool,
  formFieldPhoneValue: PropTypes.string,
  formFieldPhoneHidden: PropTypes.bool,
  formFieldIsBrokerValue: PropTypes.bool,
  formFieldIsBrokerHidden: PropTypes.bool,
  formFieldMarketingConsentGivenValue: PropTypes.bool,
  formFieldMarketingConsentGivenHidden: PropTypes.bool,
  formFieldExportVolumeCategoryValue: PropTypes.string,
  formFieldExportVolumeCategoryHidden: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

const defaultProps = {
  headline: undefined,
  description: undefined,
  leadSource: '',
  formFieldProductTypeValue: '',
  formFieldProductTypeHidden: false,
  formFieldFullNameValue: '',
  formFieldFullNameHidden: false,
  formFieldCompanyNameValue: '',
  formFieldCompanyNameHidden: false,
  formFieldCountryValue: '',
  formFieldCountryHidden: false,
  formFieldEmailValue: '',
  formFieldEmailHidden: false,
  formFieldCountryCodeValue: '',
  formFieldCountryCodeHidden: false,
  formFieldPhoneValue: '',
  formFieldPhoneHidden: false,
  formFieldIsBrokerValue: false,
  formFieldIsBrokerHidden: false,
  formFieldMarketingConsentGivenValue: false,
  formFieldMarketingConsentGivenHidden: false,
  formFieldExportVolumeCategoryValue: null,
  formFieldExportVolumeCategoryHidden: false,
  backgroundColor: undefined,
}

export type SignupHeroMediaProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const SignupHeroMedia: React.FC<SignupHeroMediaProps> = props => {
  const {headline, description, leadSource, backgroundColor, ...restProps} = props

  interface formFieldsMap {
    [key: string]: string | boolean | undefined
  }

  const formFields: formFieldsMap = Object.fromEntries(
    Object.entries(restProps).filter(field => field[0].includes('formField'))
  )

  // mapping productType of desired option format
  if (typeof formFields?.formFieldProductTypeValue === 'string') {
    formFields.formFieldProductTypeValue = formFields?.formFieldProductTypeValue
      ?.split('-')
      .join(' ')
    formFields.formFieldProductTypeValue =
      formFields?.formFieldProductTypeValue.charAt(0).toUpperCase() +
      formFields?.formFieldProductTypeValue.slice(1)
  }

  interface parsedFormFieldsMap {
    [key: string]: {
      fieldName?: string | undefined
      value?: string | boolean | undefined
      hidden?: string | boolean | undefined
    }
  }

  const parsedFormFields: parsedFormFieldsMap = {}

  Object.keys(formFields).forEach(field => {
    let fieldName = field.replace('formField', '')
    fieldName = fieldName.charAt(0).toLowerCase() + fieldName.slice(1)
    if (field.includes('Value')) {
      fieldName = fieldName.replace('Value', '')
      parsedFormFields[fieldName] = {
        ...parsedFormFields[fieldName],
        fieldName,
        value: formFields?.[field],
      }
    } else {
      fieldName = fieldName.replace('Hidden', '')
      parsedFormFields[fieldName] = {
        ...parsedFormFields[fieldName],
        fieldName,
        hidden: formFields[field],
      }
    }
  })

  return (
    <SignupFormComponentWrapper
      headline={headline}
      description={description}
      backgroundColor={backgroundColor}
    >
      <SignUpForm fieldConfig={Object.values(parsedFormFields)} leadSource={leadSource} />
    </SignupFormComponentWrapper>
  )
}

SignupHeroMedia.propTypes = propTypes

SignupHeroMedia.defaultProps = defaultProps

export default SignupHeroMedia
